module.exports = __webpack_public_path__ + "static/media/avc_pink_video.0cc32b6f.svg";